export default "__VITE_ASSET__6eddf8c9__"